import { render, staticRenderFns } from "./StudentDialog.vue?vue&type=template&id=67aa5516&scoped=true"
import script from "./StudentDialog.vue?vue&type=script&lang=js"
export * from "./StudentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa5516",
  null
  
)

export default component.exports